import React from 'react';
import Announce from './Announce';

const AnnounceContainer = props => <Announce {...props} />;

export default AnnounceContainer;
